import { useState } from "react";
import { exposeItems } from "@/mocks/homeContent";
import SectionHeading from "./SectionHeading";

const categories = ["全部", "翻车", "被扒", "黑历史"];

export default function ExposeBoard() {
  const [active, setActive] = useState("全部");
  const list =
    active === "全部" ? exposeItems : exposeItems.filter((item) => item.category === active);

  return (
    <section id="expose" className="w-full scroll-mt-20 bg-background-50 px-4 py-10 md:px-8 md:py-14">
      <SectionHeading
        eyebrow="翻车汇总"
        title="被扒、翻车与黑历史，都归到这一栏"
        desc="按类型归档，方便你按兴趣翻看学生圈的黑料学生被扒与黑料学生翻车现场，每条都标注当前核实状态。"
        action={{ label: "查看归档", href: "#expose" }}
      />

      <div className="mb-5 flex flex-wrap items-center gap-2">
        {categories.map((category) => (
          <button
            key={category}
            type="button"
            onClick={() => setActive(category)}
            aria-pressed={active === category}
            className={`cursor-pointer rounded-full px-4 py-1.5 text-sm transition-colors whitespace-nowrap ${
              active === category
                ? "bg-primary-500 font-medium text-background-50"
                : "border border-background-300/70 bg-background-50 text-foreground-600 hover:bg-background-100"
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
        {list.map((item) => (
          <article
            key={item.id}
            className="group overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-primary-200"
          >
            <div className="relative h-[160px] w-full overflow-hidden md:h-[170px]">
              <img
                src={item.cover}
                alt={`黑料学生翻车档案：${item.title}`}
                title={`${item.title} - 黑料学生被扒汇总`}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-0.5 text-[11px] font-medium text-foreground-800">
                <span className="flex h-3 w-3 items-center justify-center text-primary-500">
                  <i className="ri-fire-line text-xs"></i>
                </span>
                {item.heat}
              </span>
            </div>
            <div className="p-4">
              <span className="inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
                {item.category}
              </span>
              <h3 className="mt-2.5 text-[15px] font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                {item.title}
              </h3>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-600">{item.excerpt}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}